<template>
<div class="container-fluid min-vh-100 bg-home pt-5">

  <div class="container mt-5">

    <h1 class="display-1 fw-bold text-light py-5">Rick and Morty!</h1>

    <div class="fs-4">
      <p>This edition of Rick and Morty API uses VueJS entirely</p>
      <p>The routing is handled via VueJS Router and the Endpoints are consumed via the use of <code>fetch API</code>.</p>
      <p>Bootstrap 5.3 and SCSS are also used throughout the site.</p>
    </div>

  </div>
</div>
</template>

<script>
// @ is an alias to /src
import HelloWorld from "@/components/HelloWorld.vue";

export default {
  name: "HomeView",
  components: {
    HelloWorld,
  },
};
</script>

<style scoped>
.bg-home {
  background-color:cadetblue;
  background-image: var(--bs-gradient); 
}

</style>